<template>
  <div class="mv_signmoney">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'电影台'},{name:'签约金额'}]"></breadcrumb>
    <div class="mv_signmoney-wrap">
      <div class="mv_signmoney-contain">
        <mv-top-nav></mv-top-nav>
        <div class="mv_signmoney-search_wrap">
          <div class="mv_signmoney-search_top">
            <div class="mv_signmoney-search_left">
              <el-select @change="changeStatType"
                         style="width:135px"
                         v-model="params.statType">
                <el-option label="当前时间统计"
                           :value="0"></el-option>
                <el-option label="月末统计"
                           :value="1"></el-option>
                <el-option label="全年各月统计"
                           :value="2"></el-option>
                               <el-option label="自定义统计"
                           :value="3"></el-option>
              </el-select>
              <el-date-picker @change="changeMonth"
                              v-if="params.statType===1"
                              v-model="month"
                              type="month"
                              placeholder="选择月"></el-date-picker>
              <el-date-picker @change="changeYear"
                              v-if="params.statType === 2"
                              v-model="year"
                              type="year"
                              placeholder="选择年"></el-date-picker>
                              <el-date-picker style="width:300px" v-if="params.statType === 3" @change="timeRangeNumChange" v-model="timeRangeNum"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd">
                </el-date-picker>
              <el-select style="width:135px"
                         @change="getList()"
                         v-model="params.collect">
                <el-option label="按省汇总"
                           :value="0"></el-option>
                <el-option label="按代表处汇总"
                           :value="1"></el-option>
                           <el-option label="按个人汇总"
                           :value="2"></el-option>
              </el-select>
              <el-select v-if="params.statType===2"
                         @change="getList()"
                         v-model="params.terrace">
                <el-option label="所有平台"
                           :value="0"></el-option>
                <el-option label="亚太六"
                           :value="1"></el-option>
                <el-option label="亚七"
                           :value="2"></el-option>
              </el-select>
            </div>
            <div class="mv_signmoney-search_right">
              <a class="mv_signmoney-table_download"
                 @click="exportExcel()">
                <font-awesome-icon style="color:#39B54A;margin-right:5px"
                                   :icon="['fas', 'level-up-alt']" />导出Excel
              </a>
              <div class="mv_signmoney-table_bar"
                   @click="showChart"
                   v-if="params.statType!==2">
                <font-awesome-icon :icon="['fas', 'chart-bar']" />
              </div>
            </div>
          </div>
        </div>
        <div class="mv_signmoney-table-wrap">
          <div class="mv_signmoney-table">
            <table>
              <tr>
                <th v-if="this.params.collect===0">省份</th>
                <th v-else>代表处</th>
                <th v-if="params.statType!==2">亚太六</th>
                <th v-if="params.statType!==2">亚七</th>
                <template v-if="params.month===''&&params.statType===2">
                  <th v-for="m of 12"
                      :key="m">
                    <a @click="showMonthChart(m)">{{m}}月</a>
                  </th>
                </template>
                <th v-if="params.statType!==2">
                  <a @click="showMonthChart('总计')">总计</a>
                </th>
              </tr>
              <tr v-for="(item,index) in list"
                  :key="item.areaCode">
                <td>
                  <a @click="showCityChart(index)">{{item.areaName}}</a>
                </td>
                <td v-if="params.statType!==2">{{item.y6}}</td>
                <td v-if="params.statType!==2">{{item.y3}}</td>
                <template v-if="params.month===''&&params.statType===2">
                  <td v-for="m of 12"
                      :key="m"
                      onth>{{item[`m${m}`]}}
                  </td>
                </template>
                <td v-if="params.statType!==2">{{item.totalNum}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="mv_signmoney-chart"
               :title="chartTitle"
               :visible.sync="optionVisible"
               :width="width+20+'px'">
      <v-chart v-if="optionVisible"
               :style="{width:width+'px'}"
               :options="option"
               style="height:300px"></v-chart>
    </el-dialog>
  </div>
</template>
<script>
import ECharts from 'vue-echarts'
import 'echarts'
import axios from '@/servies/axios'
import api from '@/servies/api'
import breadcrumb from '@/components/breadcrumb'
import mvTopNav from '@/components/mvTopNav'
export default {
  components: {
    breadcrumb,
    mvTopNav,
    'v-chart': ECharts
  },
  data() {
    return {
      page: 0,
      listSize: 0,
      list: [],
      params: {
        statType: 0,
        collect: 0,
        terrace: 0,
        year: '',
        month: ''
      },
      month: '',
      year: '',
      timeRangeNum: '',

      chartTitle: '',
      width: '',
      optionVisible: false,
      option: {}
    }
  },
  created() {
    let day = new Date()
    this.params.year = day.getFullYear()
    this.params.month = day.getMonth() + 1
    this.getList()
  },
  methods: {
    getList() {
      axios
        .post(api.moneyStats, this.params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取签约金额列表成功', res.data.result)
            this.list = res.data.result
          } else {
            console.log('获取签约金额列表失败', res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    changeStatType() {
      this.params.terrace = 0
      let day = new Date()
      if (this.params.statType === 0) {
        this.params.year = day.getFullYear()
        this.params.month = day.getMonth() + 1
      } else if (this.params.statType === 2) {
        this.params.month = ''
        this.params.year = day.getFullYear()
        this.year = day
      } else if (this.params.statType === 1) {
        this.params.year = day.getFullYear()
        this.params.month = day.getMonth() + 1
        this.month = day
      } else {
        this.timeRangeNum = ''
        this.params.year = ''
        this.params.month = ''
      }

      this.params.startTime = ''
      this.params.endTime = ''
      if (this.params.statType !== 3) {
        this.getList()
      }
    },
    timeRangeNumChange() {
      this.params.startTime = this.timeRangeNum[0]
      this.params.endTime = this.timeRangeNum[1]
      this.getList()
    },
    changeMonth() {
      this.params.year = this.month.getFullYear()
      this.params.month = this.month.getMonth() + 1
      this.getList()
    },
    changeYear() {
      this.params.month = ''
      this.params.year = this.year.getFullYear()
      this.getList()
    },
    //显示城市在看客户汇总图
    showCityChart(index) {
      if (this.params.statType !== 2) {
        return
      }
             let type = this.params.terrace ==0?'所有平台':(this.params.terrace == 1? '亚太六':'亚七')
      this.width = 700
      let city = this.list[index]
      this.chartTitle =
        this.params.year + '年' + city.areaName + '签约金额汇总图 --【' + type +'】'
      this.option = {
        legend: {},
        grid: {
          x: 50,
          y: 50,
          x2: 30,
          y2: 20
        },
        tooltip: {},
        dataset: {
          source: city
        },
        xAxis: {
          type: 'category',
          data: [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月'
          ]
        },
        yAxis: {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          {
            itemStyle: {
              normal: {
                color: ['#F0722B']
              }
            },
            type: 'bar',
            data: [
              city.m1,
              city.m2,
              city.m3,
              city.m4,
              city.m5,
              city.m6,
              city.m7,
              city.m8,
              city.m9,
              city.m10,
              city.m11,
              city.m12
            ]
          }
        ]
      }
      this.optionVisible = true
    },
    //某月各城市签约金额总汇图
    showMonthChart(month) {
      let type =
        this.params.terrace == 0
          ? '所有平台'
          : this.params.terrace == 1 ? '亚太六' : '亚七'
      this.width = this.list.length * 20 < 500 ? 500 : this.list.length * 20
      this.chartTitle =
        this.params.year +
        '年' +
        (month === '总计' ? '' : month + '月') +
        '签约金额对比图 --【' +
        type +
        '】'
      this.option = {
        legend: {},
        grid: {
          x: 50,
          y: 50,
          x2: 30,
          y2: 120
        },
        tooltip: {},
        dataset: {
          source: this.list
        },
        xAxis: {
          type: 'category',
          data: this.list.map(item => {
            return item.areaName
          }),
          axisLabel: {
            interval: 0,
            formatter: function(value) {
              return value.split('').join('\n')
            },
            textStyle: {
              fontSize: 10 //更改坐标轴文字大小
            }
          }
        },
        yAxis:
          this.limit === 36
            ? [
                {
                  name: '百分比(%)'
                }
              ]
            : {},
        series: [
          {
            itemStyle: {
              normal: {
                color: ['#F0722B']
              }
            },
            type: 'bar',
            data: this.list.map(item => {
              if (month !== '总计') {
                return item['m' + month]
              } else {
                return item.totalNum
              }
            })
          }
        ]
      }
      this.optionVisible = true
    },
    //导出excel
    exportExcel() {
      axios({
        // 用axios发送post请求
        method: 'post',
        url: api.moneyStatsExport,
        data: this.params,
        responseType: 'blob' // 表明返回服务器返回的数据类型
      })
        .then(res => {
          let blob = new Blob([res.data], { type: 'application/x-xls' })
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = '签约金额列表.xls'
          link.click()
          window.URL.revokeObjectURL(link.href)
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    showChart() {
      this.width = this.list.length * 20 < 500 ? 500 : this.list.length * 20
      this.chartTitle =
        this.params.year +
        '年' +
        this.params.month +
        '月' +
        this.limitName +
        '签约金额对比图'
      this.option = {
        legend: {},
        grid: {
          x: 50,
          y: 50,
          x2: 30,
          y2: 120
        },
        tooltip: {},
        dataset: {
          source: this.list
        },
        xAxis: {
          type: 'category',
          data: this.list.map(item => {
            return item.areaName
          }),
          axisLabel: {
            interval: 0,
            formatter: function(value) {
              return value.split('').join('\n')
            },
            textStyle: {
              fontSize: 10 //更改坐标轴文字大小
            }
          }
        },
        yAxis: {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          {
            name: '亚太六',
            itemStyle: {
              normal: {
                color: ['#F0722B']
              }
            },
            type: 'bar',
            data: this.list.map(item => {
              return item.y6
            })
          },
          {
            name: '亚七',
            itemStyle: {
              normal: {
                color: ['#F51713']
              }
            },
            type: 'bar',
            data: this.list.map(item => {
              return item.y3
            })
          },
          {
            name: '总计',
            itemStyle: {
              normal: {
                color: ['#F5F513']
              }
            },
            type: 'bar',
            data: this.list.map(item => {
              return item.totalNum
            })
          }
        ]
      }
      this.optionVisible = true
    },

  }
}
</script>

<style lang="scss" scoped>
.mv_signmoney {
  .mv_signmoney-wrap {
    padding: 77px 30px 0px 30px;
    .mv_signmoney-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .mv_signmoney-search_wrap {
        position: relative;
        .mv_signmoney-search_top {
          background: #f8f8f8;
          padding: 20px 27px;
          display: flex;
          justify-content: flex-end;
          .mv_signmoney-search_left {
            display: flex;
            flex: 1;
            .el-date-editor {
              margin-right: 13px;
              width: 120px;
            }
            .el-select {
              width: 120px;
              margin-right: 13px;
            }
          }
          .mv_signmoney-search_right {
            display: flex;
            .mv_signmoney-table_bar {
              background: #fff;
              height: 40px;
              width: 50px;
              cursor: pointer;
              margin-left: 10px;
              line-height: 40px;
              text-align: center;
              border-radius: 4px;
              border: 1px solid rgba(220, 223, 230, 1);
              color: #9b9b9b;
            }
            .mv_signmoney-table_download {
              cursor: pointer;
              text-decoration: none;
              width: 108px;
              height: 38px;
              border-radius: 4px;
              background: #fff;
              margin-right: 10px;
              border: 1px solid rgba(220, 223, 230, 1);
              color: #9b9b9b;
              font-size: 14px;
              font-weight: 500;
              line-height: 38px;
              text-align: center;
            }
          }
        }
      }
      .mv_signmoney-table-wrap {
        padding: 30px 30px 30px 30px;
        .mv_signmoney-table_title {
          color: #9b9b9b;
          span {
            color: #f0722b;
          }
        }
        .mv_signmoney-table {
          margin-top: 16px;
          min-height: 470px;
          tr {
            th {
              position: sticky;
              top:113px;
              height: 40px;
              background: #5d5d5d;
              color: #fff;
              a {
                cursor: pointer;
              }
            }
            td {
              text-align: center;
              height: 54px;

              a {
                cursor: pointer;
                color: #f0722b;
              }
            }
          }
        }
        .mv_signmoney-footer {
          margin-top: 36px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
    }
  }
}
</style>
